import type { FC } from "react"

import PaymentTermsDisplay from "./PaymentTermsDisplay"

import type { CompanyAccountingTerm } from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"

interface Props {
  vendorPaymentTerm?: CompanyAccountingTerm
}

export const VendorCreditLimitItem: FC<Props> = ({ vendorPaymentTerm }) => {
  return (
    <PaymentTermsDisplay
      name='Vendor Credit Limit'
      value={vendorPaymentTerm?.creditLimit ? `$${formatNumber(vendorPaymentTerm.creditLimit)}` : ""}
    />
  )
}
